import router from '../../router';
import Segment from "../../apis/Segments";
import User from "../../apis/User";

// State
const state = {
  segments: [],
  errorSegment: "",
};

// Getters
const getters = {};

// Actions
const actions = {
  // Get
  getClientSegments({ commit }, { params = "", headers = {} }) {
    return new Promise((resolve, reject) => {
      Segment.getClientSegments(params, headers)
        .then((response) => {
          resolve(response);
          commit("GET_CLIENT_SEGMENTS", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        })
      // .finally(() => {
      //   commit("DETECT_ERROR", "");
      // });
    })
  },
  getSegments({ commit }, params = "") {
    return new Promise((resolve, reject) => {
      Segment.get(params)
        .then((response) => {
          resolve(response);
          commit("GET_SEGMENTS", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        })
      // .finally(() => {
      //   commit("DETECT_ERROR", "");
      // });
    })
  },
  // Delete 
  deleteSegment({ commit }, id) {
    return new Promise((resolve, reject) => {
      Segment.delete(id)
        .then((response) => {
          resolve(response);
          commit("DELETE_SEGMENT", id);
        })

    })
    // .catch((err) => {
    //   if (err.response) {
    //     commit("DETECT_ERROR", err.response)
    //   }
    // })
    // .finally(() => {
    //   commit("DETECT_ERROR", "")
    // })
  },
  // Store
  storeSegment({ commit }, data) {
    Segment.store(data.json)
      .then((response) => {
        // For pagination server -> if (data.length + 1 < data.itemsPerPage) { 
        commit("STORE_SEGMENT", response.data.data)
        //}
      })
    // .catch((err) => {
    //   if (err.response) {
    //     commit("DETECT_ERROR", err.response)
    //   }
    // })
    // .finally(() => {
    //   commit("DETECT_ERROR", "")
    // })
  },
  // Update
  updateSegment({ commit }, json, id) {
    Segment.update(json)
      .then(() => {
        commit("UPDATE_SEGMENT", id)
      })
    // .catch((err) => {
    //   if (err.response) {
    //     commit("DETECT_ERROR", err.response)
    //   }
    // })
    // .finally(() => {
    //   commit("DETECT_ERROR", "")
    // })
  },
};

// Mutations
const mutations = {
  // Get Segments
  GET_CLIENT_SEGMENTS(state, segments) {
    //state.segments = segments;
    state.segments = segments["data"] != undefined ? segments["data"] : segments;
  },
  // Get Segments
  GET_SEGMENTS(state, segments) {
    //state.segments = segments;
    state.segments = segments["data"] != undefined ? segments["data"] : segments;
  },
  // Delete Segment
  DELETE_SEGMENT(state, id) {
    let obj = state.segments.findIndex((el) => el.id == id)
    state.segments.splice(obj, 1)
  },
  // Store Segment
  STORE_SEGMENT(state, segment) {
    state.segments.unshift(segment)
  },
  // Update Segment
  // UPDATE_SEGMENT(state, segment) {
  //   // Content
  // },
  // Detect Error
  DETECT_ERROR(state, error) {
    if (error.status == 401 || error.status == 419) {
      User.logout().then(() => {
        localStorage.removeItem("auth");
        router.push({ name: "Login", path: router.currentRoute.path });
      })
    } else if (error.data.message !== undefined && router.currentRoute.name !== "NewWebsite") {
      state.errorSegment = error.data.message;
    }
    setTimeout(() => {
      state.errorSegment = ""
    }, 1000)
  },
};

// Export
export default {
  state,
  getters,
  actions,
  mutations,
};
